import { createContext, useContext } from "react";
import { Authorisation } from "../types";

interface AuthorisationContextProps extends Authorisation {}

const AuthorisationContext = createContext<AuthorisationContextProps | undefined>(undefined);

export const useAuthorisation = (): AuthorisationContextProps => {
  const context = useContext(AuthorisationContext);
  if (!context) {
    throw new Error("'useAuthorisation' must be used within the Authorisation Provider");
  }
  return context;
};

export { AuthorisationContext };
